<template>
    <font-awesome-icon
        icon="exclamation-circle"
        size="lg"
        :style="{ color: iconColor }"
        :title="tooltip"
    />
</template>
<script>
export default {
    props: {
        active: { type: Boolean, default: true },
    },
    data() {
        return {};
    },
    computed: {
        iconColor() {
            if (this.active) {
                return 'black';
            }
            return 'gray';
        },
        tooltip() {
            if (this.active) {
                return this.$t('createShipment.tooltip.Required');
            }
            return this.$t('createShipment.tooltip.BookingRequired');
        },
    },
};
</script>
